
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class AppImagePlaceholder extends Vue {
  @Prop({default: '100%'}) width!: string | number;
  @Prop({default: '100%'}) height!: string | number;
  @Prop({default: '#D7D7D7'}) backgroundColor!: string;
};
